import { render, staticRenderFns } from "./popup-bao-gong.vue?vue&type=template&id=1d673c9f&scoped=true"
import script from "./popup-bao-gong.vue?vue&type=script&lang=js"
export * from "./popup-bao-gong.vue?vue&type=script&lang=js"
import style0 from "./popup-bao-gong.vue?vue&type=style&index=0&id=1d673c9f&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d673c9f",
  null
  
)

export default component.exports